/**
 * The prompt of the cold-call trainer (ColdCallTrainer.tsx): the model plays
 * the prospect and answers the next line (AUDIT-ADM-12, via POST /ai/invoke
 * with feature cold_call_trainer). Kept out of the component so it can be
 * tested without a DOM.
 */
export interface TrainerLine {
  role: string;
  text: string;
}

// Instruction sent to the model (not interface copy, so not translated).
// i18n-exempt-start: instruction sent to the model (see above)
const TRAINER_PERSONAS: Record<string, string> = { ceo: 'PDG', cto: 'directeur technique', drh: 'DRH', it: 'responsable informatique' };
const TRAINER_DIFFICULTY: Record<string, string> = { easy: 'plutot ouvert', medium: 'sceptique', hard: 'tres reticent et presse' };
const TRAINER_OBJECTIVE: Record<string, string> = { rdv: 'obtenir un rendez-vous', qualification: 'qualifier son besoin', demo: 'obtenir une demonstration' };
// i18n-exempt-end

export function buildTrainerPrompt({ persona, difficulty, objective, history }: { persona: string; difficulty: string; objective: string; history: TrainerLine[] }): string {
  const transcript = history
    .slice(-20)
    .map(m => `${m.role === 'sdr' ? 'Commercial' : 'Prospect'}: ${m.text}`)
    .join('\n');
  return [
    `Tu joues un prospect B2B au telephone : ${TRAINER_PERSONAS[persona] || 'decideur'}, ${TRAINER_DIFFICULTY[difficulty] || 'sceptique'}.`,
    `Le commercial s'entraine a la prospection a froid ; son objectif est de ${TRAINER_OBJECTIVE[objective] || 'obtenir un rendez-vous'}.`,
    'Reponds UNIQUEMENT par la prochaine replique du prospect, en francais, une ou deux phrases, sans guillemets ni preambule.',
    '',
    'CONVERSATION :',
    transcript,
  ].join('\n');
}
